//Libarary
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserReportFilter } from '../../../models/user-report-filter.model';
//Service
import { ConfigService } from './../../infrastructure/config.service';
import { NetworkService } from './../../infrastructure/network.service';

@Injectable()
export class UserReportFilterService {
  constructor(public configService: ConfigService,
    private networkService: NetworkService) {
  }

  //Get User Report Filter
  public getUserReportFilters(userId: string, reportId: number): Observable<UserReportFilter[]> {
    return this.networkService.getRequest(`${this.configService.getUserReportFilterUrl()}/${userId}/${reportId}`);
  }

  //Update User Report Filter
  public updateUserReportFilters(filter: UserReportFilter): Observable<UserReportFilter> {
    return this.networkService.postRequest(`${this.configService.updateUserReportFilterUrl()}`, filter);
  }

  //Add User Report Filter
  public addUserReportFilters(filter: UserReportFilter): Observable<UserReportFilter> {
    return this.networkService.postRequest(`${this.configService.addUserReportFilterUrl()}`, filter);
  }

  //Delete User Report Filter
  public deleteUserReportFilters(filter: UserReportFilter): Observable<UserReportFilter> {
    return this.networkService.postRequest(`${this.configService.deleteUserReportFilterUrl()}`, filter);
  }
}
